import React, { useMemo, useEffect } from 'react'
import { createPortal } from 'react-dom'
import { HiCheck } from 'react-icons/hi'
import { Button } from 'components/ui'

const CONFETTI_COLORS = [
    '#0d9488', '#0f766e', '#14b8a6', '#2dd4bf', '#5eead4', // teal
    '#f59e0b', '#fbbf24', '#fcd34d', '#fde68a', // amber
    '#ef4444', '#f87171', '#fca5a5', // red
    '#8b5cf6', '#a78bfa', '#c4b5fd', // violet
    '#3b82f6', '#60a5fa', '#93c5fd', // blue
]
const CONFETTI_COUNT = 70

const ConfettiCongratsModal = ({ onClose }) => {
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape') onClose()
        }
        document.addEventListener('keydown', handleEscape)
        return () => document.removeEventListener('keydown', handleEscape)
    }, [onClose])

    const pieces = useMemo(() => {
        return Array.from({ length: CONFETTI_COUNT }, (_, i) => ({
            id: i,
            left: Math.random() * 100,
            delay: Math.random() * 0.8,
            duration: 2 + Math.random() * 1.5,
            color: CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)],
            size: 6 + Math.random() * 8,
            rotation: Math.random() * 360,
        }))
    }, [])

    return createPortal(
        <div
            className="fixed inset-0 flex items-center justify-center"
            style={{ zIndex: 2147483647 }}
            role="dialog"
            aria-modal="true"
            aria-labelledby="confetti-congrats-title"
        >
            <style>{`
                @keyframes confetti-fall {
                    0% {
                        transform: translateY(-20px) rotate(0deg);
                        opacity: 1;
                    }
                    100% {
                        transform: translateY(100vh) rotate(720deg);
                        opacity: 0;
                    }
                }
            `}</style>
            {/* Confetti layer */}
            <div className="absolute inset-0 overflow-hidden pointer-events-none">
                {pieces.map((p) => (
                    <div
                        key={p.id}
                        className="absolute rounded-sm"
                        style={{
                            left: `${p.left}%`,
                            top: '-20px',
                            width: p.size,
                            height: p.size * (Math.random() > 0.5 ? 1.2 : 0.6),
                            backgroundColor: p.color,
                            animation: `confetti-fall ${p.duration}s ease-in forwards`,
                            animationDelay: `${p.delay}s`,
                            transform: `rotate(${p.rotation}deg)`,
                        }}
                    />
                ))}
            </div>
            {/* Backdrop - click outside disabled; close via Got it or Escape only */}
            <div className="absolute inset-0 bg-black/50" aria-hidden="true" />
            {/* Modal card */}
            <div
                className="relative z-10 bg-white rounded-2xl shadow-2xl p-8 max-w-md mx-4 text-center"
                onClick={(e) => e.stopPropagation()}
            >
                <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-teal-100 flex items-center justify-center">
                    <HiCheck className="w-9 h-9 text-teal-600" />
                </div>
                <h2
                    id="confetti-congrats-title"
                    className="text-xl font-semibold text-gray-900 mb-2"
                >
                    Congratulations!
                </h2>
                <p className="text-gray-600 mb-6">
                    You&apos;ve completed the onboarding tour. You&apos;re all set to use the portal.
                </p>
                <Button
                    variant="solid"
                    // size="sm"
                    onClick={onClose}
                    // className="bg-teal-800 hover:bg-teal-700 text-white px-6 py-2.5 rounded-lg font-medium"
                >
                    Got it
                </Button>
            </div>
        </div>,
        document.body
    )
}

export default ConfettiCongratsModal
